<div class="grid grid-cols-calendar-week gap-3.5">
  <ng-content></ng-content>
</div>
